import { flatClassNameList, deduplicateClassName } from "@contember/utilities";
import { useContext } from "react";
import { GlobalClassNamePrefixContext } from "./GlobalClassNamePrefixContext.js";
import { useReferentiallyStableCallback } from "../referentiallyStable/useReferentiallyStableCallback.js";
function useClassNameFactory(componentClassName, glue = "-", prefixOverride) {
  const contextPrefix = useContext(GlobalClassNamePrefixContext);
  const classNamePrefix = prefixOverride === null || prefixOverride === "" ? "" : prefixOverride || contextPrefix;
  const componentClassNameList = flatClassNameList(componentClassName).map(
    (componentClassName2) => `${classNamePrefix}${componentClassName2}`
  );
  function componentClassNameFor(suffix = null, additionalClassName = null) {
    const classNameSuffix = suffix ?? "";
    return deduplicateClassName((classNameSuffix ? classNameSuffix.match(/^[a-zA-Z0-9]/) ? componentClassNameList.map((componentClassName2) => `${componentClassName2}${glue}${classNameSuffix}`) : componentClassNameList.map((componentClassName2) => `${componentClassName2}${classNameSuffix}`) : componentClassNameList).concat(
      flatClassNameList(additionalClassName)
    )).join(" ");
  }
  return useReferentiallyStableCallback(componentClassNameFor);
}
export {
  useClassNameFactory
};
//# sourceMappingURL=useClassNameFactory.js.map
